<script lang="ts">
    import { _ } from 'svelte-i18n';
    // import src from './Icons/images/documentation.png';
    import src from './Icons/svg/menu_book_24dp_000000_FILL0_wght400_GRAD0_opsz24.svg';
    import {
        documentationVisited,
        markDocumentationVisited,
    } from '../components/Guide/guideStore';

    export let scale: number = 1;
    export let title: string = '';

    $: hover = title || $_('help');
</script>

<button
    type="button"
    class="button"
    class:accent={!$documentationVisited}
    style="width:{30 * scale}px; height:{30 * scale}px;"
    title={hover}
    on:click={markDocumentationVisited}
    on:click
>
    <img {src} alt={hover} />
</button>

<style>
    .button {
        position: relative;
        width:46px;
        height:46px;
        box-sizing:border-box;
        border:1px solid #d9d9d9;
        border-radius:8px;
        display:flex;
        align-items:center;
        justify-content:center;
        font:700 24px/1 Arial, Helvetica, sans-serif;
        color:#222;
        user-select:none;
        cursor:pointer;
        background: none;
    }

    .button img {
        width: 24px;
        height: 24px;
        object-fit: contain;
    }

    .button.accent {
        background-color: #ffd633;
    }

    .button.accent:hover,
    .button:hover {
        background: #e5f1fd;
    }

</style>
